import { svgIconClassName } from '@archipro-design/icons';
import {
    pxToRem,
    buttonClassName,
    productTileSlotClassNames,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { THUMB_WIDTH } from './TagBarCarousel';

const CAROUSEL_ARROW_SIZE = 42;
const THUMBNAIL_IMAGE_HEIGHT = 186;
const TRANSITION_SETTINGS = '800ms linear';

export const ThumbsContainer: StyleRule = () => ({
    position: 'relative',
    overflow: 'hidden',
    maxWidth: pxToRem(1440),
    margin: '0 auto',
    [`& .${buttonClassName}`]: {
        position: 'absolute',
        top: 0,
        height: pxToRem(THUMBNAIL_IMAGE_HEIGHT),
        [`& span .${svgIconClassName}`]: {
            width: pxToRem(CAROUSEL_ARROW_SIZE),
            height: pxToRem(CAROUSEL_ARROW_SIZE),
        },
    },

    '& span[class*="carouselNavigationItem__content"]': {
        width: pxToRem(THUMB_WIDTH),
        height: 'auto',
        cursor: 'default',
    },

    '& li': {
        marginRight: 0,
        border: 'none',

        [`& .${productTileSlotClassNames.variant}`]: {
            marginRight: pxToRem(6),
        },
    },
});

export const ThumbList: StyleRule = () => {
    return {
        transition: `width ${TRANSITION_SETTINGS} !important`,
        width: '100%',
        overflow: 'hidden',
        '& ul': {
            transition: `transform ${TRANSITION_SETTINGS} !important`,
        },
    };
};

export const ThumbSlider: StyleRule<{
    slideCount: number;
    translateWidth: number;
}> = ({ slideCount, translateWidth }) => {
    const sliderWidth = slideCount * THUMB_WIDTH;
    return {
        marginTop: 0,
        padding: '0 !important',
        width: `${pxToRem(sliderWidth)} !important`,
        transform: `translate3d(${pxToRem(translateWidth)}, 0, 0) !important`,
    };
};

export const LeftNavContainer: StyleRule<{ showPrevBtn: boolean }> = ({
    showPrevBtn,
    theme,
}) => ({
    top: '0 !important',
    left: '0 !important',
    width: showPrevBtn ? pxToRem(THUMB_WIDTH) : 0,
    zIndex: 1,
    transition: `width ${TRANSITION_SETTINGS}`,
    overflow: 'hidden',
    position: 'absolute',
    backgroundColor: `${theme.siteVariables.bodyBackground} !important`,
    height: '100%',
    '& svg': {
        opacity: showPrevBtn ? '1' : '0',
        transition: `opacity ${TRANSITION_SETTINGS}`,
    },
});

export const RightNavContainer: StyleRule<{ showNextBtn: boolean }> = ({
    showNextBtn,
    theme,
}) => ({
    top: '0 !important',
    right: '0 !important',
    width: showNextBtn ? pxToRem(THUMB_WIDTH) : 0,
    zIndex: 1,
    transition: `width ${TRANSITION_SETTINGS}`,
    overflow: 'hidden',
    position: 'absolute',
    backgroundColor: `${theme.siteVariables.bodyBackground} !important`,
    height: '100%',
    '& button': {
        right: 0,
        position: 'absolute',
    },
    '& svg': {
        opacity: showNextBtn ? '1' : '0',
        transition: `opacity ${TRANSITION_SETTINGS}`,
    },
});

export const NavBtn: StyleRule = ({ theme }) => ({
    width: pxToRem(THUMBNAIL_IMAGE_HEIGHT),
    ':hover': {
        backgroundColor: `${theme.siteVariables.bodyBackground} !important`,
    },
});
